// import {
//   Button,
//   Box,
//   createStyles,
//   Text,
//   Select,
//   Checkbox,
//   TextInput,
//   Group,
//   Modal,
//   Radio,
//   Textarea,
// } from "@mantine/core";
// import { useEffect, useState } from "react";
// import { IconChevronDown, IconDots, IconPlus } from "@tabler/icons-react";
// import { useSelector } from "react-redux";
// import { useForm } from "@mantine/form";
// import swal from "sweetalert";

// import { DatePickerInput } from "@mantine/dates";
// import InvoiceItemTable from "./Invoiceitemtable";
// import {
//   EditBillingInvoice,
//   getAllBillingInvoices,
// } from "../../../services/billinginvoice";
// import Newconsumer from "./Newconsumer";

// const useStyles = createStyles(() => ({
//   modalBody: {
//     '& .mantine-1q36a81:not(:only-child)':{
//       paddingTop: '1rem',
//       background:"rgb(245, 245, 245)"
//     }
//   },
//   addbox: {
//     padding: "12px 12px",
//     borderRadius: "12px",
//     border: "1px solid #E5E5EA",
//     background: "#FFF",
//   },
//   formtabs: {},
//   tablists: {
//     width: "100%",
//     marginBottom: "1rem",
//     "& .mantine-thcgkg[data-active]": {
//       borderColor: "#000",
//     },
//   },
//   tabBtns: {
//     width: "50%",
//   },
//   formRow: {
//     width: "100%",
//     display: "flex",
//     justifyContent: "space-between",
//     marginBottom: "20px",
//     gap: "1rem",
//     "@media (max-width:1300px)": {
//       // flexDirection: "column",
//       // gap: "10px",
//     },

//     mt19: {
//       marginTop: "19px",
//     },

//     boxtype: {
//       display: "flex",
//       flexDirection: "row",
//     },
//   },
//   formRowItem: {
//     width: "100%",
//   },
//   selectnumber: {
//     width: "120px",
//     padding: "5px 15px",
//     borderRadius: "5px",
//     backgroundColor: bgColor,
//     // width: "50%",
//     "& input": {
//       backgroundColor: "transparent",
//       border: "none",
//       paddingInline: 0,
//     },
//   },

//   selectbilling: {
//     width: "70px",
//     padding: "5px 5px",
//     borderRadius: "5px",
//     backgroundColor: bgColor,
//     // width: "50%",
//     "& input": {
//       backgroundColor: "transparent",
//       border: "none",
//       paddingInline: 0,
//     },
//   },

//   selecttext: {
//     width: "120px",
//     padding: "5px 15px",
//     borderRadius: "5px",
//     backgroundColor: bgColor,
//     "& input": {
//       backgroundColor: "transparent",
//       border: "none",
//       paddingInline: 0,
//     },
//   },

//   line: {
//     width: "2px",
//     height: "42.011px",
//     background: "#525252",
//   },

//   dflex: {
//     display: "flex",
//     justifyContent: "space-between",
//   },

//   flexend: {
//     display: "flex",
//     justifyContent: "flex-end",
//   },

//   addbtn: {
//     display: "flex",
//     justifyContent: "flex-end",
//     marginTop: "8px",
//   },

//   boxnumber: {
//     display: "flex",
//     flexDirection: "row",
//     width: "100%",
//     // width: "min-content",
//     // justifyContent:'flex-end'
//   },

//   radiobox: {
//     color: "#000",
//     fontFamily: "Inter",
//     fontSize: "12px !important",
//     fontWeight: 500,
//     marginTop:8,
//     '& input':{
//       marginTop:3,
//       height:13,
//       width:13,
//     },
//     '& input.mantine-1cu6yj8:checked':{
//       background: "#000",
//       borderColor: "#000",
//     },
  
//     '& svg':{
//       display:'none'
//     }
//   },

//   datePicker: {
//     width: "100%",
//     "& .mantine-InputWrapper-label": {
//       // marginLeft: 10,
//       fontSize:15
//     },
//     "& .mantine-DatePickerInput-input": {
//       borderRadius: 8,
//       border: "1px solid #D4D4D4",
//       background: "#FFF",
//       boxShadow:
//         "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F2F4F7",
//       height:48,
//       minHeight:48
//     },
//   },

//   itembox: {
//     borderRadius: 8,
//     border: "1px solid #E5E5E5",
//     background: "#FCFCFC",
//      padding: "20px",
//     width: "100%",
//   },

//   recurringbox: {
//     marginTop: "24px",
//     marginBottom: "24px",
//     background: "#f2f2f2",
//     borderRadius: "8px",
//     border: "1px solid #E5E5E5",
//     display: "flex",
//     justifyContent: "center",
//     gap: "72px",
//     alignItems: "center",
//     margin: "auto",
//     padding: "6px 13px",
//   },

//   recuuringselect: {
//     marginTop: "20px",
//     marginBottom: "20px",
//     justifyContent: "center",
//     display: "flex",
//   },
// }));
// const bgColor = "#D9D9D9";

// const CustomTextInput = ({ ...rest }) => {
//   const useStyles = createStyles((theme) => ({
//     textInputBox: {
//       width: "100%",
//       padding: "5px 15px",
//       borderRadius: "5px",
//       // backgroundColor: bgColor,
//       border: "1px solid " + bgColor,

//       "& input": {
//         backgroundColor: "transparent",
//         border: "none",
//         paddingInline: 0,
//       },
//     },
//   }));
//   const { classes } = useStyles();

//   return (
//     <div className={classes.textInputBox}>
//       <TextInput {...rest} />
//     </div>
//   );
// };

// const CustomSelectBox = ({ ...rest }) => {
//   const useStyles = createStyles((theme) => ({
//       textInputBox: {
//         width: "100%",
//         padding: "5px 11px",
//         borderRadius: "5px",
//         // backgroundColor: bgColor,
//         border: "1px solid " + bgColor,
  
//         "& input": {
//           border: "none",
//           paddingInline: 0,
//           backgroundColor: "transparent",
//         },
//       },
//     }));
//   const { classes } = useStyles();

//   return (
//     <div className={classes.textInputBox}>
//       <Select
//         {...rest}
//         rightSection={<IconChevronDown color={"#FBAA0D"} size={20} />}
//         rightSectionWidth={25}
//         styles={{ rightSection: { pointerEvents: "none" } }}
//       />
//     </div>
//   );
// };

// function EditInvoice({
//   editinvoice,
//   setEditinvoice,
//   invoice,
//   setInvoice,
//   isPreview,
//   setIsPreview,
// }) {
//   const { classes } = useStyles();

//   const { profile } = useSelector((state) => state?.profile);
//   // console.log('profile',profile);

//   const [invoiceNumberOption, setInvoiceNumberOption] = useState("");

//   const { allbillinginvoicesConsumer } = useSelector(
//     (state) => state.billinginvoiceReducer
//   );
//   const [rows, setRows] = useState(
//     invoice?.interventionDetails || [{ name: "", quantity: 0, amount: 0 }]
//   );

//   const [expires, setExpires] = useState(invoice?.recurringEndDate || true);

//   // const [rows, setRows] = useState(invoice?.interventionDetails ||
//   //     [{ name: "", quantity: 0, amount: 0 }]);

//   // console.log('invoice',invoice);

//   const [recurring, setRecurring] = useState(invoice?.recurring || false);
//   const [paid, setPaid] = useState(invoice?.status === "Paid");

//   const [consumer, setConsumer] = useState([]);

//   const [dateRangeVal, setDateRangeVal] = useState([]);

//   //  console.log('paid',paid);

//   const [createconsumer, setCreateConsumer] = useState(false);

//   // console.log("createconsumer", createconsumer);

//   const form = useForm({
//     initialValues: {
//       consumer: "",
//       invoiceNumber: "",
//       invoiceTitle: "",
//       invoiceDueDate: null,
//       notes: "",
//       term: "",
//       Frequency: null,
//       recurringDate: null,
//       recurringEndDate: null,
//       invoiceCreatedDate: null,
//     },
//   });

//   const [currentStep, setCurrentStep] = useState(0);

//   const handleRecurringChange = (event) => {
//     setRecurring(event.target.checked);
//   };

//   const handlePaymentChange = (event) => {
//     // console.log('event',event);

//     setPaid(event);
//   };

//   const handleRadioChange = (value) => {
//     setInvoiceNumberOption(value);
//     if (value === "auto") {
//       const newInvoiceNumber = `INV-${String(
//         Math.floor(Math.random() * 10000)
//       ).padStart(4, "0")}`;
//       form.setFieldValue("invoiceNumber", newInvoiceNumber);
//     } else {
//       form.setFieldValue("invoiceNumber", "");
//     }
//   };

//   useEffect(() => {
//     if (recurring === false) {
//       form.setValues({
//         ...form.values,
//         recurringDate: null,
//       });
//     }
//   }, [recurring]);

//   const renderContent = () => {
//     switch (currentStep) {
//       case 0:
//         return (
//           <>
//             <form>
//               <Box className={classes.addbox}>
//                 <div className={classes.formRow}>
//                   <Box className={classes.formRowItem}>
//                     <Text ff={"Inter"} fz={15} fw={500} color="#262626">
//                       Customer Name
//                     </Text>
//                     <Box className={classes.boxnumber}>
//                       <CustomSelectBox
//                           //  value={invoice?.consumer?.name || "hamza"}
//                           //  onChange={(selectedValue) => form.setFieldValue("consumer", selectedValue)}
//                         id="consumer"
//                         placeholder={"Select or Add a new name"}
//                         disabled={isPreview}
//                         withAsterisk
//                         searchable
//                         data={(
//                           allbillinginvoicesConsumer?.billinginvoice
//                         )?.map((item) => ({
//                           value: item?.id,
//                           label: item?.name,
//                         }))}
//                        //  value={consumer.name} 
//                         // onChange={(selectedValue) => form.setFieldValue("consumer", selectedValue)}
//                         {...form.getInputProps("consumer")}
//                       />
//                     </Box>
//                     {!isPreview ? (
//                       <div
//                         style={{
//                           cursor: "pointer",
//                           color: "#007bff",
//                           marginTop: "8px",
//                           fontWeight: "bold",
//                         }}
//                         onClick={() => setCreateConsumer(true)}
//                       >
//                         + Add New Consumer
//                       </div>
//                     ) : null}
//                   </Box>
//                   <Box className={classes.formRowItem}>
//                     <Box style={{ gap: "10px" }} className={classes.dflex}>
//                       <Text ff={"Inter"} fz={15} fw={500} color="#262626">
//                         Invoice Number
//                       </Text>
//                       <Group>
//                         <Radio
//                           className={classes.radiobox}
//                           checked={invoiceNumberOption === "auto"}
//                           label="Auto-Generated"
//                           value="auto"
//                           onChange={() => handleRadioChange("auto")}
//                         />
//                         <Radio
//                           className={classes.radiobox}
//                           checked={invoiceNumberOption === "manual"}
//                           label="Manual"
//                           value="manual"
//                           onChange={() => handleRadioChange("manual")}
//                         />
//                       </Group>
//                     </Box>
//                     <Box className={classes.boxnumber}>
//                       <CustomTextInput
//                         id="invoice-Number"
//                         // label={"Facility Name"}
//                         size="sm"
//                         placeholder={"INV-001"}
//                         // placeholder={"Enter Medication Name"}
//                         // {...form.getInputProps("medicationName")}
//                         withAsterisk
//                         {...form.getInputProps("invoiceNumber")}
//                         disabled={isPreview}
//                       />

//                       {/* <Box className={classes.line}></Box> */}
//                     </Box>
//                   </Box>
//                 </div>

//                 <div className={classes.formRow}>
//                   <Box className={classes.formRowItem}>
//                     <Text ff={"Inter"} fz={15} fw={500} color="#262626">
//                       Invoice Title *
//                     </Text>
//                     <Box className={classes.boxnumber}>
//                       <CustomTextInput
//                         id="invoice-Title"
//                         size="sm"
//                         placeholder={"Enter Invoice Title"}
//                         withAsterisk
//                         {...form.getInputProps("invoiceTitle")}
//                         disabled={isPreview}
//                       />
//                     </Box>
//                   </Box>

//                   <Box className={[classes.datePicker, classes.formRowItem]}>
//                     <DatePickerInput
//                       id="invoice-date"
//                       label="Invoice Date *"
//                       size="xl"
//                       placeholder="mm/dd/yyyy"
//                       rightSection={
//                         <img
//                           style={{ width: "30px" }}
//                           src={"/assets/images/calendar-icon.png"}
//                           alt="Icon"
//                         />
//                       }
//                       // withAsterisk
//                       styles={{ rightSection: { pointerEvents: "none" } }}
//                       {...form.getInputProps("invoiceCreatedDate")}
//                       disabled={isPreview}
//                     />
//                   </Box>
//                 </div>

//                 <div className={classes.formRow}>
//                   <Box className={classes.formRowItem}>
//                     <Text ff={"Inter"} fz={15} fw={500} color="#262626">
//                       Invoice Term *
//                     </Text>
//                     <Box className={classes.boxnumber}>
//                       <CustomSelectBox
//                         id="billing-type"
//                         placeholder={"Select or Add a new name"}
//                         withAsterisk
//                         searchable
//                         data={[
//                           { value: "net5", label: "Net 5" },
//                           { value: "net10", label: "Net 10" },
//                           { value: "net15", label: "Net 15" },
//                           { value: "net30", label: "Net 30" },
//                           { value: "net45", label: "Net 45" },
//                           { value: "endofmonthdue", label: "Due End of Month" },
//                           {
//                             value: "dueendofnextmonth",
//                             label: "Due End of Next Month",
//                           },
//                           { value: "custom", label: "Custom" },
//                         ]}
//                         {...form.getInputProps("term")}
//                         disabled={isPreview}
//                       />
//                     </Box>
//                   </Box>

//                   <Box className={[classes.datePicker, classes.formRowItem]}>
//                     <DatePickerInput
//                       id="due-date"
//                       label="Due Date"
//                       size="xl"
//                       placeholder="mm/dd/yyyy"
//                       rightSection={
//                         <img
//                           style={{ width: "30px" }}
//                           src={"/assets/images/calendar-icon.png"}
//                           alt="Icon"
//                         />
//                       }
//                       // withAsterisk
//                       styles={{ rightSection: { pointerEvents: "none" } }}
//                       {...form.getInputProps("invoiceDueDate")}
//                       disabled={form.values.term !== "custom" || isPreview}
//                     />
//                   </Box>
//                 </div>

//                 {recurring ? (
//                   <>
//                     <Box className={classes.recuuringselect}>
//                       <Text
//                         ff={"Inter"}
//                         fz={14}
//                         fw={500}
//                         color="#262626"
//                         style={{ width: "100%" }}
//                       >
//                         Select Frequency
//                         <CustomSelectBox
//                           placeholder="Select frequency"
//                           default="weekly"
//                           data={[
//                             { value: "weekly", label: "Weekly" },
//                             { value: "monthly", label: "Monthly" },
//                             { value: "yearly", label: "Yearly" },
//                             {
//                               value: "Every two Months",
//                               label: "Every two Months",
//                             },
//                           ].map((item) => ({
//                             value: item.value,
//                             label: item.label,
//                           }))}
//                           // value={selectedCode?.id}
//                           // onChange={handleSelectChange}
//                           {...form.getInputProps("Frequency")}
//                           disabled={isPreview}
//                         />
//                       </Text>
//                     </Box>
//                     <Box style={{ gap: "10px" }} className={classes.dflex}>
//                       <Box className={classes.formRowItem}>
//                         <DatePickerInput
//                           // id="due-date"
//                           // label="Due Date"
//                           label="Recurring Start Date *"
//                           size="lg"
//                           placeholder="mm/dd/yyyy"
//                           rightSection={
//                             <img
//                               style={{ width: "30px" }}
//                               src={"/assets/images/calendar-icon.png"}
//                               alt="Icon"
//                             />
//                           }
//                           // withAsterisk
//                           styles={{
//                             rightSection: { pointerEvents: "none" },
//                           }}
//                           {...form.getInputProps("recurringDate")}
//                           disabled={isPreview}
//                         />
//                       </Box>

//                       <Box
//                         className={[classes.datePicker, classes.formRowItem]}
//                       >
//                         <DatePickerInput
//                           // id="due-date"
//                           label="Recurring End Date"
//                           size="lg"
//                           disabled={expires||isPreview}
//                           placeholder="mm/dd/yyyy"
//                           rightSection={
//                             <img
//                               style={{ width: "30px" }}
//                               src={"/assets/images/calendar-icon.png"}
//                               alt="Icon"
//                             />
//                           }
//                           // withAsterisk
//                           styles={{
//                             rightSection: { pointerEvents: "none" },
//                           }}
//                           {...form.getInputProps("recurringEndDate")}
//                           //   disabled={isPreview}
//                         />
//                         {/* <Box> */}
//                         <Checkbox
//                           label="Never Expires"
//                           sx={{
//                             marginTop: 8,
//                             "& input:checked": {
//                               background: "#000",
//                               borderColor: "#000",
//                             },
//                             "& input:checked": {
//                               background: "#000",
//                               borderColor: "#000",
//                             },
//                           }}
//                           defaultChecked={expires}
//                           onChange={(v) => {
//                             setExpires(v?.target?.checked);
//                           }}
//                           // disabled={view}
//                           color="yellow"
//                         />
//                         {/* </Box> */}
//                       </Box>
//                     </Box>
//                   </>
//                 ) : null}

//                 <Text
//                   style={{ marginTop: "28px", marginBottom: "28px" }}
//                   ff={"Inter"}
//                   fz={18}
//                   fw={600}
//                   color="#000"
//                 >
//                   {/* Intervention Details */}
//                   Invoice Description
//                 </Text>

//                 <Box className={classes.itembox}>
//                   <InvoiceItemTable rows={rows} setRows={setRows} isPreview={isPreview}  dateRangeVal={dateRangeVal} setDateRangeVal={setDateRangeVal}  />

//                   {/* <Text style={{background: '#E5E5E5'}}  ff={"Inter"} fz={14} fw={600} color="#262626">Item Table</Text> */}
//                   <Box style={{ marginTop: "10px", marginBottom: "10px" }}>
//                     <Text ff={"Inter"} fz={14} fw={500} color="#262626">
//                       Notes
//                     </Text>
//                   </Box>

//                   <Textarea
//                     //   label="Input label"
//                     //   description="Input description"
//                     disabled={isPreview}
//                     autosize
//                     minRows={6}
//                     placeholder="Enter Notes"
//                     {...form.getInputProps("notes")}
//                   />
//                 </Box>

//                 {/* <Box className={classes.recurringbox}>
//                   <Box>
//                     <Text ff={"Inter"} fz={12} fw={400} color="#737373">
//                       Make Reoccurring
//                       <Checkbox
//                         disabled={isPreview}
//                         //  checked={invoice?.recurring }
//                         checked={recurring}
//                         onChange={handleRecurringChange}
//                         // label="No Guardian"
//                         // ref={noGuardianRef}
//                         // defaultChecked={form2?.noGuardian}
//                         // {...form.getInputProps("noGuardian")}
//                         // sx={{ marginTop: 20 }}
//                         // onChange={(v) => setRecurring(v?.target?.checked)}
//                         //disabled={view}
//                         color="yellow"
//                       />
//                     </Text>
//                   </Box>
//                 </Box> */}

//                 {/* {recurring ? (
//                   <>
//                     <Box className={classes.recuuringselect}>
//                       <Text ff={"Inter"} fz={14} fw={500} color="#262626">
//                         Select Frequency
//                         <CustomSelectBox
//                           placeholder="Select frequency"
//                           default="weekly"
//                           data={[
//                             { value: "weekly", label: "Weekly" },
//                             { value: "monthly", label: "Monthly" },
//                             { value: "yearly", label: "Yearly" },
//                             {
//                               value: "Every two Months",
//                               label: "Every two Months",
//                             },
//                           ].map((item) => ({
//                             value: item.value,
//                             label: item.label,
//                           }))}
//                           // value={selectedCode?.id}
//                           // onChange={handleSelectChange}
//                           {...form.getInputProps("Frequency")}
//                         />
//                       </Text>
//                     </Box>
//                     <Box style={{ gap: "10px" }} className={classes.dflex}>
//                       <Box>
//                         <DatePickerInput
//                           // id="due-date"
//                           // label="Due Date"
//                           label="Recurring Start Date *"
//                           size="lg"
//                           placeholder="mm/dd/yyyy"
//                           rightSection={
//                             <img
//                               style={{ width: "30px" }}
//                               src={"/assets/images/calendar-icon.png"}
//                               alt="Icon"
//                             />
//                           }
//                           // withAsterisk
//                           styles={{ rightSection: { pointerEvents: "none" } }}
//                           {...form.getInputProps("recurringDate")}
//                           //   disabled={isPreview}
//                         />
//                       </Box>

//                       <Box>
//                         <DatePickerInput
//                           // id="due-date"
//                           label="Recurring End Date"
//                           size="lg"
//                           disabled={expires}
//                           placeholder="mm/dd/yyyy"
//                           rightSection={
//                             <img
//                               style={{ width: "30px" }}
//                               src={"/assets/images/calendar-icon.png"}
//                               alt="Icon"
//                             />
//                           }
//                           // withAsterisk
//                           styles={{ rightSection: { pointerEvents: "none" } }}
//                           {...form.getInputProps("recurringEndDate")}
//                           //   disabled={isPreview}
//                         />
//                       </Box>

//                       <Box>
//                         <Checkbox
//                           label="Never Expires"
//                           sx={{ marginTop: 20 }}
//                           defaultChecked={expires}
//                           onChange={(v) => {
//                             setExpires(v?.target?.checked);
//                           }}
//                           //disabled={view}
//                           color="yellow"
//                         />
//                       </Box>
//                     </Box>
//                   </>
//                 ) : null} */}

//                 {/* {!profile?.user.type ? (
//                   <Box style={{ marginTop: "20px" }}>
//                     <Text ff={"Inter"} fz={14} fw={500} color="#262626">
//                       Payment Status
//                     </Text>
//                     <Checkbox
//                       label="Paid"
//                       sx={{ marginTop: 20 }}
//                       checked={paid}
//                       onChange={(v) => {
//                         handlePaymentChange(v?.target?.checked);
//                       }}
//                       //disabled={view}
//                       color="yellow"
//                     />
//                   </Box>
//                 ) : null}

//                 {!profile?.user.type ? (
//                   <Box style={{ marginTop: "20px" }}>
//                     <Text ff={"Inter"} fz={14} fw={500} color="#262626">
//                       Payment Status
//                     </Text>
//                     <Checkbox
//                       label="Paid"
//                       sx={{ marginTop: 20 }}
//                       checked={paid}
//                       onChange={(v) => {
//                         handlePaymentChange(v?.target?.checked);
//                       }}
//                       //disabled={view}
//                       color="yellow"
//                     />
//                   </Box>
//                 ) : null} */}

//                 <Box
//                   style={{ marginTop: "20px", marginBottom: "20px" }}
//                   className={classes.dflex}
//                 >
//                   <Button
//                     variant="filled"
//                     onClick={handleClose}
//                     c={"#000"}
//                     style={{ width: "40%" }}
//                     // className={classes.backNextBtn}
//                     color="gray"
//                     size="md"
//                   >
//                     Save as Draft
//                   </Button>

//                   <Button
//                     disabled={isPreview}
//                     onClick={onSave}
//                     variant="filled"
//                     style={{ width: "40%" }}
//                     c={"#000"}
//                     radius={"md"}
//                     size="md"
//                     color="yellow"
//                     // className={classes.backNextBtn}
//                   >
//                     Send
//                   </Button>
//                 </Box>
//               </Box>
//             </form>
//           </>
//         );

//       default:
//         return null;
//     }
//   };

//   const onSave = async () => {
//     const values = form.values;
//     const calculateTotal = () =>
//       rows.reduce((total, row) => total + row.quantity * row.amount, 0);

//     let payload = {
//       ...values,
//       interventionDetails: rows,
//       totalAmount: calculateTotal().toFixed(2),
//       recurring,
//       id: invoice.id,
//       status: paid === true ? "Paid" : "unpaid",
//     };

//     const res = await EditBillingInvoice(payload);

//     // await updatestate(res);

//     if (res.status === 200) {
//       getAllBillingInvoices();
//       swal({
//         title: `Invoice updated successfully`,
//         text: "Invoice updated successfully",
//         dangerMode: false,
//       });
//       setInvoice(null);
//       setRecurring(false);
//       setRows([]);
//       handleClose();
//     }
//   };

//   useEffect(() => {
//     if (invoice) {
//       form.setValues({
//         consumer: invoice?.consumer?.id || "",
//         invoiceNumber: invoice?.invoiceNumber || "",
//         invoiceTitle: invoice?.invoiceTitle || "",
//         invoiceDueDate: invoice?.invoiceDueDate
//           ? new Date(invoice?.invoiceDueDate)
//           : null,
//         notes: invoice?.notes || "",
//         term: invoice?.term || "",
//         Frequency: invoice?.Frequency || null,
//         recurringDate: invoice?.recurringDate
//           ? new Date(invoice?.recurringDate)
//           : null,
//         recurringEndDate: invoice?.recurringEndDate
//           ? new Date(invoice?.recurringEndDate)
//           : null,
//         invoiceCreatedDate: invoice?.invoiceCreatedDate
//           ? new Date(invoice?.invoiceCreatedDate)
//           : null,
//       });

//       setInvoiceNumberOption(invoice?.InvoiceNumberType || "manual")
//       setDateRangeVal(invoice?.serviceEndDate ? [new Date(invoice?.serviceStartDate), new Date(invoice?.serviceEndDate)] : [])

//       setRows(invoice?.interventionDetails);
//       setRecurring(invoice?.recurring);
//       setPaid(invoice?.status === "Paid" ? true : false);
//       setConsumer(invoice?.consumer)
//     }
//   }, [invoice]);


//   //  console.log('invoice',invoice);

//   // console.log('form',form.values);
//   // console.log('cosumer',consumer);
  
  

//   useEffect(() => {
//     if (invoiceNumberOption === "auto") {
//       const newInvoiceNumber = `INV-${String(
//         Math.floor(Math.random() * 10000)
//       ).padStart(4, "0")}`;
//       form.setFieldValue("invoiceNumber", newInvoiceNumber);
//     }
//   }, [invoiceNumberOption]);

//   useEffect(() => {
//     const { invoiceCreatedDate, term } = form.values;

//     if (invoiceCreatedDate && term) {
//       let dueDate = null;

//       // Calculate due date based on selected term
//       if (term === "net5") {
//         dueDate = new Date(invoiceCreatedDate);
//         dueDate.setDate(dueDate.getDate() + 5); // Add 5 days to invoice date
//       } else if (term === "net10") {
//         dueDate = new Date(invoiceCreatedDate);
//         dueDate.setDate(dueDate.getDate() + 10); // Add 10 days to invoice date
//       } else if (term === "net15") {
//         dueDate = new Date(invoiceCreatedDate);
//         dueDate.setDate(dueDate.getDate() + 15); // Add 15 days to invoice date
//       } else if (term === "net30") {
//         dueDate = new Date(invoiceCreatedDate);
//         dueDate.setDate(dueDate.getDate() + 30); // Add 30 days to invoice date
//       } else if (term === "net45") {
//         dueDate = new Date(invoiceCreatedDate);
//         dueDate.setDate(dueDate.getDate() + 45); // Add 45 days to invoice date
//       } else if (term === "endofmonthdue") {
//         dueDate = new Date(invoiceCreatedDate);
//         dueDate.setMonth(dueDate.getMonth() + 1);
//         dueDate.setDate(1);
//         dueDate.setDate(dueDate.getDate() - 1);
//       } else if (term === "dueendofnextmonth") {
//         // Get last date of the next month
//         dueDate = new Date(invoiceCreatedDate);
//         dueDate.setMonth(dueDate.getMonth() + 2);
//         dueDate.setDate(0); // Set it to the last day of the next month
//       }

//       if (term !== "custom" && dueDate) {
//         form.setFieldValue("invoiceDueDate", dueDate);
//       }
//     }
//   }, [form.values.invoiceCreatedDate, form.values.term]);

//   const handleClose = () => {
//     setIsPreview(false);
//     setEditinvoice(false);
//   };

//   return (
//     <>
//       <Modal
//         opened={editinvoice}
//         size={1000}
//         // title="View Invoice"
//         title={
//           <div style={{ fontSize: "1.3rem", fontWeight: 700 }}>
//           View Invoice
//           </div>
//         }
//         shadow="md"
//         onClose={handleClose}
//         overlayProps={{ blur: 3 }}
//         radius={"lg"}
//         zIndex={1000}
//         centered
//       >
//         <Box>{renderContent()}</Box>
//       </Modal>

//       <Newconsumer
//         createconsumer={createconsumer}
//         setCreateConsumer={setCreateConsumer}
//       />
//     </>
//   );
// }

// export default EditInvoice;

import {
  Button,
  Box,
  createStyles,
  Text,
  Select,
  Checkbox,
  TextInput,
  Group,
  Modal,
  Radio,
  Textarea,
  Anchor,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { IconChevronDown, IconDots, IconPlus } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { useForm } from "@mantine/form";
import swal from "sweetalert";

import { DatePickerInput } from "@mantine/dates";
import InvoiceItemTable from "./Invoiceitemtable";
import {
  EditBillingInvoice,
  getAllBillingInvoices,
} from "../../../services/billinginvoice";
import Newconsumer from "./Newconsumer";

const useStyles = createStyles(() => ({
  modalBody: {
    "& .mantine-1q36a81:not(:only-child)": {
      paddingTop: "1rem",
      background: "rgb(245, 245, 245)",
    },
  },
  addbox: {
    padding: "12px 12px",
    borderRadius: "12px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
  },
  formtabs: {},
  tablists: {
    width: "100%",
    marginBottom: "1rem",
    "& .mantine-thcgkg[data-active]": {
      borderColor: "#000",
    },
  },
  tabBtns: {
    width: "50%",
  },
  formRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
    gap: "1rem",
    "@media (max-width:1300px)": {
      // flexDirection: "column",
      // gap: "10px",
    },

    mt19: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },
  },
  formRowItem: {
    width: "100%",
  },
  selectnumber: {
    width: "120px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  selectbilling: {
    width: "70px",
    padding: "5px 5px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  selecttext: {
    width: "120px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  dflex: {
    display: "flex",
    justifyContent: "space-between",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  addbtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "8px",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    // width: "min-content",
    // justifyContent:'flex-end'
  },

  radiobox: {
    color: "#000",
    fontFamily: "Inter",
    fontSize: "12px !important",
    fontWeight: 500,
    marginTop: 8,
    "& input": {
      marginTop: 3,
      height: 13,
      width: 13,
    },
    "& input.mantine-1cu6yj8:checked": {
      background: "#000",
      borderColor: "#000",
    },

    "& svg": {
      display: "none",
    },
  },

  datePicker: {
    width: "100%",
    "& .mantine-InputWrapper-label": {
      // marginLeft: 10,
      fontSize: 15,
    },
    "& .mantine-DatePickerInput-input": {
      borderRadius: 8,
      border: "1px solid #D4D4D4",
      background: "#FFF",
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F2F4F7",
      height: 48,
      minHeight: 48,
    },
  },

  itembox: {
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    background: "#FCFCFC",
    padding: "20px",
    width: "100%",
  },

  recurringbox: {
    marginTop: "24px",
    marginBottom: "24px",
    background: "#f2f2f2",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    display: "flex",
    justifyContent: "center",
    gap: "72px",
    alignItems: "center",
    margin: "auto",
    padding: "6px 13px",
  },

  recuuringselect: {
    marginTop: "20px",
    marginBottom: "20px",
    justifyContent: "center",
    display: "flex",
  },
}));
const bgColor = "#D9D9D9";

const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 15px",
      borderRadius: "5px",
      // backgroundColor: bgColor,
      border: "1px solid " + bgColor,

      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 11px",
      borderRadius: "5px",
      // backgroundColor: bgColor,
      border: "1px solid " + bgColor,

      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#FBAA0D"} size={20} />}
        rightSectionWidth={25}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

function EditInvoice({
  editinvoice,
  setEditinvoice,
  invoice,
  setInvoice,
  isPreview,
  setIsPreview,
}) {
  const { classes } = useStyles();

  const { profile } = useSelector((state) => state?.profile);
  // console.log('profile',profile);

  const [invoiceNumberOption, setInvoiceNumberOption] = useState("");

  const { allbillinginvoicesConsumer } = useSelector(
    (state) => state.billinginvoiceReducer
  );
  const [rows, setRows] = useState(
    invoice?.interventionDetails || [{ name: "", quantity: 0, amount: 0 }]
  );

  const [expires, setExpires] = useState(invoice?.recurringEndDate || true);

  // const [rows, setRows] = useState(invoice?.interventionDetails ||
  //     [{ name: "", quantity: 0, amount: 0 }]);

  // console.log('invoice',invoice);

  const [recurring, setRecurring] = useState(invoice?.recurring || false);
  const [paid, setPaid] = useState(invoice?.status === "Paid");

  const [consumer, setConsumer] = useState([]);

  const [dateRangeVal, setDateRangeVal] = useState([]);

  //  console.log('paid',paid);

  const [createconsumer, setCreateConsumer] = useState(false);

  // console.log("createconsumer", createconsumer);

  const form = useForm({
    initialValues: {
      consumer: "",
      invoiceNumber: "",
      invoiceTitle: "",
      invoiceDueDate: null,
      notes: "",
      term: "",
      Frequency: null,
      recurringDate: null,
      recurringEndDate: null,
      invoiceCreatedDate: null,
    },
  });

  const [currentStep, setCurrentStep] = useState(0);

  const handleRecurringChange = (event) => {
    setRecurring(event.target.checked);
  };

  const handlePaymentChange = (event) => {
    // console.log('event',event);

    setPaid(event);
  };

  const handleRadioChange = (value) => {
    setInvoiceNumberOption(value);
    if (value === "auto") {
      const newInvoiceNumber = `INV-${String(
        Math.floor(Math.random() * 10000)
      ).padStart(4, "0")}`;
      form.setFieldValue("invoiceNumber", newInvoiceNumber);
    } else {
      form.setFieldValue("invoiceNumber", "");
    }
  };

  useEffect(() => {
    if (recurring === false) {
      form.setValues({
        ...form.values,
        recurringDate: null,
      });
    }
  }, [recurring]);

  const renderContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <form>
              <Box className={classes.addbox}>
                <div className={classes.formRow}>
                  <Box className={classes.formRowItem}>
                    <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                      Customer Name
                    </Text>
                    <Box className={classes.boxnumber}>
                      <CustomSelectBox
                        //  value={invoice?.consumer?.name || "hamza"}
                        //  onChange={(selectedValue) => form.setFieldValue("consumer", selectedValue)}
                        id="consumer"
                        placeholder={"Select or Add a new name"}
                        disabled={isPreview}
                        withAsterisk
                        searchable
                        data={allbillinginvoicesConsumer?.billinginvoice?.map(
                          (item) => ({
                            value: item?.id,
                            label: item?.name,
                          })
                        )}
                        //  value={consumer.name}
                        // onChange={(selectedValue) => form.setFieldValue("consumer", selectedValue)}
                        {...form.getInputProps("consumer")}
                      />
                    </Box>
                    {!isPreview ? (
                      <div
                        style={{
                          cursor: "pointer",
                          color: "#007bff",
                          marginTop: "8px",
                          fontWeight: "bold",
                        }}
                        onClick={() => setCreateConsumer(true)}
                      >
                        + Add New Consumer
                      </div>
                    ) : null}
                  </Box>
                  <Box className={classes.formRowItem}>
                    <Box style={{ gap: "10px" }} className={classes.dflex}>
                      <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                        Invoice Number
                      </Text>
                      <Group>
                        <Radio
                          className={classes.radiobox}
                          checked={invoiceNumberOption === "auto"}
                          label="Auto-Generated"
                          value="auto"
                          onChange={() => handleRadioChange("auto")}
                        />
                        <Radio
                          className={classes.radiobox}
                          checked={invoiceNumberOption === "manual"}
                          label="Manual"
                          value="manual"
                          onChange={() => handleRadioChange("manual")}
                        />
                      </Group>
                    </Box>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Number"
                        // label={"Facility Name"}
                        size="sm"
                        placeholder={"INV-001"}
                        // placeholder={"Enter Medication Name"}
                        // {...form.getInputProps("medicationName")}
                        withAsterisk
                        {...form.getInputProps("invoiceNumber")}
                        disabled={isPreview}
                      />

                      {/* <Box className={classes.line}></Box> */}
                    </Box>
                  </Box>
                </div>

                <div className={classes.formRow}>
                  <Box className={classes.formRowItem}>
                    <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                      Invoice Title *
                    </Text>
                    <Box className={classes.boxnumber}>
                      <CustomTextInput
                        id="invoice-Title"
                        size="sm"
                        placeholder={"Enter Invoice Title"}
                        withAsterisk
                        {...form.getInputProps("invoiceTitle")}
                        disabled={isPreview}
                      />
                    </Box>
                  </Box>

                  <Box className={[classes.datePicker, classes.formRowItem]}>
                    <DatePickerInput
                      id="invoice-date"
                      label="Invoice Date *"
                      size="xl"
                      placeholder="mm/dd/yyyy"
                      rightSection={
                        <img
                          style={{ width: "30px" }}
                          src={"/assets/images/calendar-icon.png"}
                          alt="Icon"
                        />
                      }
                      // withAsterisk
                      styles={{ rightSection: { pointerEvents: "none" } }}
                      {...form.getInputProps("invoiceCreatedDate")}
                      disabled={isPreview}
                    />
                  </Box>
                </div>

                <div className={classes.formRow}>
                  <Box className={classes.formRowItem}>
                    <Text ff={"Inter"} fz={15} fw={500} color="#262626">
                      Invoice Term *
                    </Text>
                    <Box className={classes.boxnumber}>
                      <CustomSelectBox
                        id="billing-type"
                        placeholder={"Select or Add a new name"}
                        withAsterisk
                        searchable
                        data={[
                          { value: "net5", label: "Net 5" },
                          { value: "net10", label: "Net 10" },
                          { value: "net15", label: "Net 15" },
                          { value: "net30", label: "Net 30" },
                          { value: "net45", label: "Net 45" },
                          { value: "endofmonthdue", label: "Due End of Month" },
                          {
                            value: "dueendofnextmonth",
                            label: "Due End of Next Month",
                          },
                          { value: "custom", label: "Custom" },
                        ]}
                        {...form.getInputProps("term")}
                        disabled={isPreview}
                      />
                    </Box>
                  </Box>

                  <Box className={[classes.datePicker, classes.formRowItem]}>
                    <DatePickerInput
                      id="due-date"
                      label="Due Date"
                      size="xl"
                      placeholder="mm/dd/yyyy"
                      rightSection={
                        <img
                          style={{ width: "30px" }}
                          src={"/assets/images/calendar-icon.png"}
                          alt="Icon"
                        />
                      }
                      // withAsterisk
                      styles={{ rightSection: { pointerEvents: "none" } }}
                      {...form.getInputProps("invoiceDueDate")}
                      disabled={form.values.term !== "custom" || isPreview}
                    />
                  </Box>
                </div>

                {recurring ? (
                  <>
                    <Box className={classes.recuuringselect}>
                      <Text
                        ff={"Inter"}
                        fz={14}
                        fw={500}
                        color="#262626"
                        style={{ width: "100%" }}
                      >
                        Select Frequency
                        <CustomSelectBox
                          placeholder="Select frequency"
                          default="weekly"
                          data={[
                            { value: "weekly", label: "Weekly" },
                            { value: "monthly", label: "Monthly" },
                            { value: "yearly", label: "Yearly" },
                            {
                              value: "Every two Months",
                              label: "Every two Months",
                            },
                          ].map((item) => ({
                            value: item.value,
                            label: item.label,
                          }))}
                          // value={selectedCode?.id}
                          // onChange={handleSelectChange}
                          {...form.getInputProps("Frequency")}
                          disabled={isPreview}
                        />
                      </Text>
                    </Box>
                    <Box style={{ gap: "10px" }} className={classes.dflex}>
                      <Box className={classes.formRowItem}>
                        <DatePickerInput
                          // id="due-date"
                          // label="Due Date"
                          label="Recurring Start Date *"
                          size="lg"
                          placeholder="mm/dd/yyyy"
                          rightSection={
                            <img
                              style={{ width: "30px" }}
                              src={"/assets/images/calendar-icon.png"}
                              alt="Icon"
                            />
                          }
                          // withAsterisk
                          styles={{
                            rightSection: { pointerEvents: "none" },
                          }}
                          {...form.getInputProps("recurringDate")}
                          disabled={isPreview}
                        />
                      </Box>

                      <Box
                        className={[classes.datePicker, classes.formRowItem]}
                      >
                        <DatePickerInput
                          // id="due-date"
                          label="Recurring End Date"
                          size="lg"
                          disabled={expires || isPreview}
                          placeholder="mm/dd/yyyy"
                          rightSection={
                            <img
                              style={{ width: "30px" }}
                              src={"/assets/images/calendar-icon.png"}
                              alt="Icon"
                            />
                          }
                          // withAsterisk
                          styles={{
                            rightSection: { pointerEvents: "none" },
                          }}
                          {...form.getInputProps("recurringEndDate")}
                          //   disabled={isPreview}
                        />
                        {/* <Box> */}
                        <Checkbox
                          label="Never Expires"
                          sx={{
                            marginTop: 8,
                            "& input:checked": {
                              background: "#000",
                              borderColor: "#000",
                            },
                            "& input:checked": {
                              background: "#000",
                              borderColor: "#000",
                            },
                          }}
                          defaultChecked={expires}
                          onChange={(v) => {
                            setExpires(v?.target?.checked);
                          }}
                          // disabled={view}
                          color="yellow"
                        />
                        {/* </Box> */}
                      </Box>
                    </Box>
                  </>
                ) : null}

                <Text
                  style={{ marginTop: "28px", marginBottom: "28px" }}
                  ff={"Inter"}
                  fz={18}
                  fw={600}
                  color="#000"
                >
                  {/* Intervention Details */}
                  Invoice Description
                </Text>

                <Box className={classes.itembox}>
                  <InvoiceItemTable
                    rows={rows}
                    setRows={setRows}
                    isPreview={isPreview}
                    dateRangeVal={dateRangeVal}
                    setDateRangeVal={setDateRangeVal}
                  />
                  {invoice?.documents && invoice?.documents?.length > 0 ? (
                    <>
                      <Box style={{ marginTop: "20px", marginBottom: "20px" }}>
                        <Box mt="10px">
                          <strong>Uploaded Files:</strong>
                          <ul style={{ margin: "5px 0", paddingLeft: "20px" }}>
                            {invoice?.documents?.map((file, index) => (
                              <li key={index}>
                                <Anchor
                                  href={file.documentUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {file.documentName}
                                </Anchor>
                              </li>
                            ))}
                          </ul>
                        </Box>
                      </Box>
                    </>
                  ) : null}
                  {/* <Text style={{background: '#E5E5E5'}}  ff={"Inter"} fz={14} fw={600} color="#262626">Item Table</Text> */}
                  <Box style={{ marginTop: "10px", marginBottom: "10px" }}>
                    <Text ff={"Inter"} fz={14} fw={500} color="#262626">
                      Notes
                    </Text>
                  </Box>

                  <Textarea
                    //   label="Input label"
                    //   description="Input description"
                    disabled={isPreview}
                    autosize
                    minRows={6}
                    placeholder="Enter Notes"
                    {...form.getInputProps("notes")}
                  />
                </Box>

                {/* <Box className={classes.recurringbox}>
                  <Box>
                    <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                      Make Reoccurring
                      <Checkbox
                        disabled={isPreview}
                        //  checked={invoice?.recurring }
                        checked={recurring}
                        onChange={handleRecurringChange}
                        // label="No Guardian"
                        // ref={noGuardianRef}
                        // defaultChecked={form2?.noGuardian}
                        // {...form.getInputProps("noGuardian")}
                        // sx={{ marginTop: 20 }}
                        // onChange={(v) => setRecurring(v?.target?.checked)}
                        //disabled={view}
                        color="yellow"
                      />
                    </Text>
                  </Box>
                </Box> */}

                {/* {recurring ? (
                  <>
                    <Box className={classes.recuuringselect}>
                      <Text ff={"Inter"} fz={14} fw={500} color="#262626">
                        Select Frequency
                        <CustomSelectBox
                          placeholder="Select frequency"
                          default="weekly"
                          data={[
                            { value: "weekly", label: "Weekly" },
                            { value: "monthly", label: "Monthly" },
                            { value: "yearly", label: "Yearly" },
                            {
                              value: "Every two Months",
                              label: "Every two Months",
                            },
                          ].map((item) => ({
                            value: item.value,
                            label: item.label,
                          }))}
                          // value={selectedCode?.id}
                          // onChange={handleSelectChange}
                          {...form.getInputProps("Frequency")}
                        />
                      </Text>
                    </Box>
                    <Box style={{ gap: "10px" }} className={classes.dflex}>
                      <Box>
                        <DatePickerInput
                          // id="due-date"
                          // label="Due Date"
                          label="Recurring Start Date *"
                          size="lg"
                          placeholder="mm/dd/yyyy"
                          rightSection={
                            <img
                              style={{ width: "30px" }}
                              src={"/assets/images/calendar-icon.png"}
                              alt="Icon"
                            />
                          }
                          // withAsterisk
                          styles={{ rightSection: { pointerEvents: "none" } }}
                          {...form.getInputProps("recurringDate")}
                          //   disabled={isPreview}
                        />
                      </Box>

                      <Box>
                        <DatePickerInput
                          // id="due-date"
                          label="Recurring End Date"
                          size="lg"
                          disabled={expires}
                          placeholder="mm/dd/yyyy"
                          rightSection={
                            <img
                              style={{ width: "30px" }}
                              src={"/assets/images/calendar-icon.png"}
                              alt="Icon"
                            />
                          }
                          // withAsterisk
                          styles={{ rightSection: { pointerEvents: "none" } }}
                          {...form.getInputProps("recurringEndDate")}
                          //   disabled={isPreview}
                        />
                      </Box>

                      <Box>
                        <Checkbox
                          label="Never Expires"
                          sx={{ marginTop: 20 }}
                          defaultChecked={expires}
                          onChange={(v) => {
                            setExpires(v?.target?.checked);
                          }}
                          //disabled={view}
                          color="yellow"
                        />
                      </Box>
                    </Box>
                  </>
                ) : null} */}

                {/* {!profile?.user.type ? (
                  <Box style={{ marginTop: "20px" }}>
                    <Text ff={"Inter"} fz={14} fw={500} color="#262626">
                      Payment Status
                    </Text>
                    <Checkbox
                      label="Paid"
                      sx={{ marginTop: 20 }}
                      checked={paid}
                      onChange={(v) => {
                        handlePaymentChange(v?.target?.checked);
                      }}
                      //disabled={view}
                      color="yellow"
                    />
                  </Box>
                ) : null}

                {!profile?.user.type ? (
                  <Box style={{ marginTop: "20px" }}>
                    <Text ff={"Inter"} fz={14} fw={500} color="#262626">
                      Payment Status
                    </Text>
                    <Checkbox
                      label="Paid"
                      sx={{ marginTop: 20 }}
                      checked={paid}
                      onChange={(v) => {
                        handlePaymentChange(v?.target?.checked);
                      }}
                      //disabled={view}
                      color="yellow"
                    />
                  </Box>
                ) : null} */}

                <Box
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                  className={classes.dflex}
                >
                  <Button
                    variant="filled"
                    onClick={handleClose}
                    c={"#000"}
                    style={{ width: "40%" }}
                    // className={classes.backNextBtn}
                    color="gray"
                    size="md"
                  >
                    Save as Draft
                  </Button>

                  <Button
                    disabled={isPreview}
                    onClick={onSave}
                    variant="filled"
                    style={{ width: "40%" }}
                    c={"#000"}
                    radius={"md"}
                    size="md"
                    color="yellow"
                    // className={classes.backNextBtn}
                  >
                    Send
                  </Button>
                </Box>
              </Box>
            </form>
          </>
        );

      default:
        return null;
    }
  };

  const onSave = async () => {
    const values = form.values;
    const calculateTotal = () =>
      rows.reduce((total, row) => total + row.quantity * row.amount, 0);

    let payload = {
      ...values,
      interventionDetails: rows,
      totalAmount: calculateTotal().toFixed(2),
      recurring,
      id: invoice.id,
      status: paid === true ? "Paid" : "unpaid",
    };

    const res = await EditBillingInvoice(payload);

    // await updatestate(res);

    if (res.status === 200) {
      getAllBillingInvoices();
      swal({
        title: `Invoice updated successfully`,
        text: "Invoice updated successfully",
        dangerMode: false,
      });
      setInvoice(null);
      setRecurring(false);
      setRows([]);
      handleClose();
    }
  };

  useEffect(() => {
    if (invoice) {   
      form.setValues({
        consumer: invoice?.consumer?._id || invoice?.consumer?.id|| "",
        invoiceNumber: invoice?.invoiceNumber || "",
        invoiceTitle: invoice?.invoiceTitle || "",
        invoiceDueDate: invoice?.invoiceDueDate
          ? new Date(invoice?.invoiceDueDate)
          : null,
        notes: invoice?.notes || "",
        term: invoice?.term || "",
        Frequency: invoice?.Frequency || null,
        recurringDate: invoice?.recurringDate
          ? new Date(invoice?.recurringDate)
          : null,
        recurringEndDate: invoice?.recurringEndDate
          ? new Date(invoice?.recurringEndDate)
          : null,
        invoiceCreatedDate: invoice?.invoiceCreatedDate
          ? new Date(invoice?.invoiceCreatedDate)
          : null,
      });

      setInvoiceNumberOption(invoice?.InvoiceNumberType || "manual");
      setDateRangeVal(
        invoice?.serviceEndDate
          ? [
              new Date(invoice?.serviceStartDate),
              new Date(invoice?.serviceEndDate),
            ]
          : []
      );

      setRows(invoice?.interventionDetails);
      setRecurring(invoice?.recurring);
      setPaid(invoice?.status === "Paid" ? true : false);
      setConsumer(invoice?.consumer);
    }
  }, [invoice]);

    // console.log('invoice',invoice);

  // console.log('form',form.values);
  // console.log('cosumer',consumer);

  useEffect(() => {
    if (invoiceNumberOption === "auto") {
      const newInvoiceNumber = `INV-${String(
        Math.floor(Math.random() * 10000)
      ).padStart(4, "0")}`;
      form.setFieldValue("invoiceNumber", newInvoiceNumber);
    }
  }, [invoiceNumberOption]);

  useEffect(() => {
    const { invoiceCreatedDate, term } = form.values;

    if (invoiceCreatedDate && term) {
      let dueDate = null;

      // Calculate due date based on selected term
      if (term === "net5") {
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setDate(dueDate.getDate() + 5); // Add 5 days to invoice date
      } else if (term === "net10") {
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setDate(dueDate.getDate() + 10); // Add 10 days to invoice date
      } else if (term === "net15") {
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setDate(dueDate.getDate() + 15); // Add 15 days to invoice date
      } else if (term === "net30") {
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setDate(dueDate.getDate() + 30); // Add 30 days to invoice date
      } else if (term === "net45") {
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setDate(dueDate.getDate() + 45); // Add 45 days to invoice date
      } else if (term === "endofmonthdue") {
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setMonth(dueDate.getMonth() + 1);
        dueDate.setDate(1);
        dueDate.setDate(dueDate.getDate() - 1);
      } else if (term === "dueendofnextmonth") {
        // Get last date of the next month
        dueDate = new Date(invoiceCreatedDate);
        dueDate.setMonth(dueDate.getMonth() + 2);
        dueDate.setDate(0); // Set it to the last day of the next month
      }

      // if (term !== "custom" && dueDate) {
      //   form.setFieldValue("invoiceDueDate", dueDate);
      // }
    if (term !== "custom" && dueDate) {
      // ✅ only update if different
      if (!form.values.invoiceDueDate || new Date(form.values.invoiceDueDate).getTime() !== dueDate.getTime()) {
        form.setFieldValue("invoiceDueDate", dueDate);
      }
    }
      
    }
  }, [form.values.invoiceCreatedDate, form.values.term]);

  const handleClose = () => {
    setIsPreview(false);
    setEditinvoice(false);
  };

  return (
    <>
      <Modal
        opened={editinvoice}
        size={1000}
        // title="View Invoice"
        title={
          <div style={{ fontSize: "1.3rem", fontWeight: 700 }}>
            View Invoice
          </div>
        }
        shadow="md"
        onClose={handleClose}
        overlayProps={{ blur: 3 }}
        radius={"lg"}
        zIndex={1000}
        centered
      >
        <Box>{renderContent()}</Box>
      </Modal>

      <Newconsumer
        createconsumer={createconsumer}
        setCreateConsumer={setCreateConsumer}
      />
    </>
  );
}

export default EditInvoice;
